module.exports = __webpack_public_path__ + "static/media/folder_01_C.14bc713d.png";